module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Here's The Breakdown!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Our Impact So Far...")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_Backpack.svg"),
      "width": "75",
      "height": "75"
    }
  }), _vm._v(" "), (_vm.backpacks) ? _c('h4', [_vm._v(_vm._s(_vm._f("commafy")(_vm.backpacks)))]) : _c('h4', [_vm._v("XXXXX")]), _vm._v(" "), _c('p', [_vm._v("Backpacks given in Myanmar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_Shirt.svg"),
      "width": "120",
      "height": "120"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("£10")]), _vm._v(" "), _c('p', [_vm._v("Cost of School Uniforms")])]), _vm._v(" "), _c('div', {
    staticClass: "module"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("assets/images/PFK_Icon_PieChart.svg"),
      "width": "120",
      "height": "120"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("⅓")]), _vm._v(" "), _c('p', [_vm._v("Of Average Rural Family's income")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3ffef2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Breakdown.vue
// module id = 411
// module chunks = 2